module.exports = __webpack_public_path__ + "static/media/Ketan_Kale.661958d7.jpg";